import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  token,
  locale,
  alert,
  tokens,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import THUMBNAIL from "../assets/images/thumbnail.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photo_about: "",
      title_about: "",
      message_about: "",
      title_about_2: "",
      message_about_2: "",
      photo_about_3: [],
      photo_about_4: [],
      photo_about_5: [],
    };
  }
  componentDidMount = async () => {
    loading(false);
    this.Get();
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      photo_about: result?.setting?.photo_about,
      photo_about_3: result?.setting?.photo_about_3,
      photo_about_4: result?.setting?.photo_about_4,
      photo_about_5: result?.setting?.photo_about_5,
      title_about:
        result?.setting[`${locale}_title_about`] ||
        result?.setting?.th_title_about,
      message_about:
        result?.setting[`${locale}_message_about`] ||
        result?.setting?.th_message_about,
      title_about_2:
        result?.setting[`${locale}_title_about_2`] ||
        result?.setting?.th_title_about_2,
      message_about_2:
        result?.setting[`${locale}_message_about_2`] ||
        result?.setting?.th_message_about_2,
      title_about_4:
        result?.setting[`${locale}_title_about_4`] ||
        result?.setting?.th_title_about_4,
      message_about_4:
        result?.setting[`${locale}_message_about_4`] ||
        result?.setting?.th_message_about_4,
      title_about_5:
        result?.setting[`${locale}_title_about_5`] ||
        result?.setting?.th_title_about_5,
      message_about_5:
        result?.setting[`${locale}_message_about_5`] ||
        result?.setting?.th_message_about_5,
    });
    loading(false);
  };
  render() {
    const {
      photo_about,
      photo_about_3,
      photo_about_4,
      title_about,
      message_about,
      title_about_2,
      message_about_2,
      title_about_4,
      message_about_4,
      title_about_5,
      message_about_5,
      photo_about_5,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />

        {/* HEADER */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-5.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">เกี่ยวกับเรา</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 1 */}
        <div className="row bg-secondary-light">
          <div className="col-12 col-md-6 col-lg-6">
            <div
              className="d-none d-md-block position-relative align-content-center"
              style={{
                minHeight: 600,
                backgroundImage: `
          linear-gradient(to left,
            rgba(234, 236, 243,1),
            rgba(234, 236, 243,0.2),
            rgba(234, 236, 243,0),
            rgba(234, 236, 243,0)
          ),
          url(${photo_about || THUMBNAIL})
        `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
            <div
              className="d-block d-md-none position-relative align-content-center"
              style={{
                minHeight: 600,
                backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_about || THUMBNAIL})
                    `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </div>

          <div className="col-12 col-md-6 col-lg-6 text-start px-5">
            <div className="my-5 py-4">
              <h2 className="fw-bold mb-4">{title_about}</h2>
              <div className="text-secondary">{message_about}</div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="py-5 px-4">
          <div className="bg-primary-light p-4 rounded-4">
            <h4 className="fw-bold mb-2 text-primary text-center">
              {title_about_2}
            </h4>
            <div className="text-secondary px-4">
              {message_about_2?.split("\n").map((item) => (
                <div>{item}</div>
              ))}
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="py-5 bg-secondary-light">
          {photo_about_3.map((item, index) => (
            <div className="d-flex">
              <div className="w-100 p-4 d-none d-md-block">
                {index % 2 === 1 ? (
                  <div className="rounded-4 bg-light p-3 text-end">
                    <h5 className="fw-bold text-primary">
                      {item[locale]?.title || item.th.title}
                    </h5>
                    <img
                      alt="example"
                      src={item.image}
                      className="w-100 my-3"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                    <span>
                      {item[locale]?.description || item.th.description}
                    </span>
                  </div>
                ) : (
                  <div className="text-end">
                    <h5 className="fw-bold text-primary">
                      {item[locale]?.year || item.th.year}
                    </h5>
                    <span>{item[locale]?.detail || item.th.detail}</span>
                  </div>
                )}
              </div>
              <div className="wpx-60">
                {index === 0 && (
                  <div
                    className="hpx-10 wpx-10 rounded-circle mx-auto"
                    style={{ backgroundColor: "#9f9f9f", height: 8 }}
                  ></div>
                )}
                <div
                  className="hpx-20 mx-auto"
                  style={{ width: 4, backgroundColor: "#9f9f9f" }}
                ></div>
                <div
                  className="hpx-60 wpx-60 rounded-circle mx-auto d-flex align-items-center justify-content-center p-1"
                  style={{ backgroundColor: "#9f9f9f" }}
                >
                  <div className="w-100 h-100 rounded-circle bg-primary mx-auto d-flex align-items-center justify-content-center">
                    <span className="icon text-light text-36">{"\uf017"}</span>
                  </div>
                </div>
                <div
                  className="h-100 mx-auto"
                  style={{ width: 4, backgroundColor: "#9f9f9f" }}
                ></div>
                {index === photo_about_3.length - 1 && (
                  <div
                    className="hpx-10 wpx-10 rounded-circle mx-auto"
                    style={{ backgroundColor: "#9f9f9f" }}
                  ></div>
                )}
              </div>
              <div className="w-100 p-4">
                {index % 2 === 0 ? (
                  <div className="rounded-4 bg-light p-3">
                    <div className="d-block d-md-none mb-2">
                      <h5 className="fw-bold text-primary mb-1">
                        {item[locale]?.year || item.th.year}
                      </h5>
                      <span>{item[locale]?.detail || item.th.detail}</span>
                    </div>
                    <h5 className="fw-bold text-primary">
                      {item[locale]?.title || item.th.title}
                    </h5>
                    <img
                      alt="example"
                      src={item.image}
                      className="w-100 my-3"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                    <span>
                      {item[locale]?.description || item.th.description}
                    </span>
                  </div>
                ) : (
                  <div>
                    <div className="d-none d-md-block">
                      <h5 className="fw-bold text-primary">
                        {item[locale]?.year || item.th.year}
                      </h5>
                      <span>{item[locale]?.detail || item.th.detail}</span>
                    </div>
                    <div className="rounded-4 bg-light p-3 d-block d-md-none">
                      <div className="d-block d-md-none mb-2">
                        <h5 className="fw-bold text-primary mb-1">
                          {item[locale]?.year || item.th.year}
                        </h5>
                        <span>{item[locale]?.detail || item.th.detail}</span>
                      </div>
                      <h5 className="fw-bold text-primary">
                        {item[locale]?.title || item.th.title}
                      </h5>
                      <img
                        alt="example"
                        src={item.image}
                        className="w-100 my-3"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <span>
                        {item[locale]?.description || item.th.description}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
          <div className="hpx-100"></div>
        </div>

        {/* SECTION 4 */}
        <div className="row bg-secondary-light">
          <div className="col-12 col-md-6 col-lg-6 text-start px-5">
            <div className="my-5 py-4">
              <h2 className="fw-bold mb-4">{title_about_4}</h2>
              <div className="text-secondary">{message_about_4}</div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6">
            <div
              className="d-none d-md-block position-relative align-content-center"
              style={{
                minHeight: 600,
                backgroundImage: `
          linear-gradient(to right,
            rgba(234, 236, 243,1),
            rgba(234, 236, 243,0.2),
            rgba(234, 236, 243,0),
            rgba(234, 236, 243,0)
          ),
          url(${photo_about_4 || THUMBNAIL})
        `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
            <div
              className="d-block d-md-none position-relative align-content-center"
              style={{
                minHeight: 600,
                backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_about_4 || THUMBNAIL})
                    `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </div>
        </div>
        {/* SECTION 4 */}
        <div className="container text-center">
          <div className="my-5 py-4">
            <h2 className="fw-bold mb-4">{title_about_5}</h2>
            <div className="text-secondary mb-4">{message_about_5}</div>
            <img
              alt="THUMBNAIL"
              src={photo_about_5 || THUMBNAIL}
              className="h-100 w-100 rounded-3"
              style={{ objectFit: "cover", minHeight: 200 }}
            />
          </div>
        </div>

        <div className="hpx-30"></div>
        <Footer />
      </div>
    );
  }
}
